const LAST_CHOSEN_ORG_KEY = "last_chosen_org";

export const clearLastChosenOrg = () =>
    localStorage.removeItem(LAST_CHOSEN_ORG_KEY);

export const readLastChosenOrg = () =>
    localStorage.getItem(LAST_CHOSEN_ORG_KEY);

export const storeLastChosenOrg = (orgShortName: string) =>
    localStorage.setItem(LAST_CHOSEN_ORG_KEY, orgShortName);
